import { Heading, VStack, Button, Image, Text, Center } from "@chakra-ui/react";
import CheckIcon from "./../../assets/checkIcon.svg";
import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const ThankYou = ({ type = "Pool", name = "" }) => {
  const setTimeoutRef = useRef();
  const navigate = useNavigate();
  const { state } = useLocation();
  type = state.type;
  name = state.name;

  useEffect(() => {
    if (type === "Pool") redirectToResumePool();
  }, []);

  /* To prevent auto redirect to batch-ops route if home button clicked*/
  const stopRedirect = () => {
    clearTimeout(setTimeoutRef.current);
  };

  /*Redirect to Create Resume Pool URL after Pool Creation to show progress*/
  const redirectToResumePool = () => {
    setTimeoutRef.current = setTimeout(() => {
      navigate("/home/batch-ops");
    }, 3000);
  };

  const homeBtnHandler = () => {
    stopRedirect();
    navigate("/home");
  };

  return (
    <Center h="70vh">
      <VStack>
        <Heading as="h1" size="4xl" noOfLines={1}>
          Thank You!
        </Heading>
        <Image py="10" boxSize="200px" src={CheckIcon} alt="Check"></Image>
        <Text fontSize="2xl">
          New {type}
          <strong>
            &nbsp;
            {name}&nbsp;
          </strong>
          has been created!
        </Text>
        <Button size="sm" colorScheme="blue" onClick={homeBtnHandler}>
          Go Home
        </Button>
      </VStack>
    </Center>
  );
};

export default ThankYou;
